import ScrollToTop from "../../components/scrollToTop/scrollToTop";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./style.css";
import navBarEn from "../../translations/en/navbar.json";
import navBarEs from "../../translations/es/navbar.json";
import Helmet from "react-helmet";
import ReactMarkdown from "react-markdown";

function LogisticsContract() {
  const [tLogisticsContract] = useTranslation("LogisticsContract");
  const [tSMetaData] = useTranslation("metaData");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].logisticsContract}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].logisticsContract}`
  );

  return (
    <>
      <Helmet>
        <title>{tSMetaData("contratoServiciosLogistica.title")}</title>
        <meta
          name="description"
          content={tSMetaData("contratoServiciosLogistica.description")}
        />
      </Helmet>
      <ScrollToTop />
      <Navbar />
      <section className="logistics_box">
        <div className="row">
          <div className="p-3">
            <Link className="text-decoration-none" to="/contracts">
              {tLogisticsContract("logistica.button")}
            </Link>
          </div>
          <div className="title_logistics">
            <div className="col">
              <h1 className="carga_logistics">
                {tLogisticsContract("logistica.titulo")}
              </h1>
              <div className="box_logistics">
                <p className="aerea_logistics">
                  {tLogisticsContract("logistica.subtitulo")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="texto_box">
              <div className="container conta-texto">
                {/* parrafo1 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo1")}
                  </ReactMarkdown>
                </div>
                {/* parrafo2 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo2")}
                  </ReactMarkdown>
                </div>
                {/* parrafo3 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo3")}
                  </ReactMarkdown>
                </div>
                {/* parrafo4 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo4")}
                  </ReactMarkdown>
                </div>
                {/* parrafo5 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo5")}
                  </ReactMarkdown>
                </div>
                {/* parrafo6 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo6")}
                  </ReactMarkdown>
                </div>
                {/* parrafo7 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo7")}
                  </ReactMarkdown>
                </div>
                {/* parrafo8 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo8")}
                  </ReactMarkdown>
                </div>
                {/* parrafo9 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo9")}
                  </ReactMarkdown>
                </div>
                {/* parrafo10 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo10")}
                  </ReactMarkdown>
                </div>
                {/* parrafo11 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo11")}
                  </ReactMarkdown>
                </div>
                {/* parrafo12 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo12")}
                  </ReactMarkdown>
                </div>
                {/* parrafo13 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo13")}
                  </ReactMarkdown>
                </div>
                {/* parrafo14 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo14")}
                  </ReactMarkdown>
                </div>
                {/* parrafo15 */}
                <div className="contract-section">
                  <ReactMarkdown>
                    {tLogisticsContract("parrafo15")}
                  </ReactMarkdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-3">
          <Link className="text-decoration-none" to="/contracts">
            {tLogisticsContract("logistica.button")}
          </Link>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default LogisticsContract;
